import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import OggHeading40 from 'components/common/text/OggHeading40'
import { Roles } from 'consts/authConsts'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useRolePermissions from 'hooks/useRolePermissions'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import AutochartSettings from './AutochartSettings/AutochartSettings'
import BlueDotSettings from './BlueDotSettings/BlueDotSettings'
import BulkCreatePatients from './BulkCreatePatients/BulkCreatePatients'
import BulkInvite from './BulkInvite/BulkInvite'
import DefaultPatientTabSettings from './DefaultPatientTabSettings/DefaultPatientTabSettings'
import UrgentScan from './UrgentScan/UrgentScanSettings'

const useStyles = makeStyles(theme => ({
  root: {
    width: 538,
    paddingBottom: 50
  },
  heading: {
    marginBottom: 20
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: 'var(--border-color-13)',
    marginBottom: 35
  }
}))

const AdvancedActions = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  const { permissions, isHiUser, isUserOfRole } = useRolePermissions()
  const isInternalSupport = isUserOfRole(Roles.Admin) || isUserOfRole(Roles.OpsAdmin) || isUserOfRole(Roles.DevAdmin)
  const { autochart: autochartFF, createRecordsOnlyPatients: createRecordsOnlyPatientsFF } = useFeatureFlags()
  const actions = useMemo(
    () => [
      {
        type: 'bulkInvite',
        component: BulkInvite,
        condition: () => true
      },
      {
        type: 'bulkCreatePatients',
        component: BulkCreatePatients,
        condition: () => createRecordsOnlyPatientsFF && permissions.invitePatient
      },
      {
        type: 'blueDot',
        component: BlueDotSettings,
        condition: () => permissions.updateBlueDotBehaviour
      },
      {
        type: 'urgenScan',
        component: UrgentScan,
        condition: () => permissions.toggleUrgentScanOption
      },
      {
        type: 'defaultPatientTab',
        component: DefaultPatientTabSettings,
        condition: () => true
      },
      {
        type: 'autochartSettings',
        component: AutochartSettings,
        condition: () => !!autochartFF || isHiUser || isInternalSupport
      }
    ],
    [
      permissions.updateBlueDotBehaviour,
      permissions.toggleUrgentScanOption,
      permissions.invitePatient,
      createRecordsOnlyPatientsFF,
      autochartFF,
      isHiUser,
      isInternalSupport
    ]
  )

  return (
    <div className={classes.root}>
      <OggHeading40 textAlign="left" className={classes.heading}>
        {t('pages.accountSettings.advancedActions.title')}
      </OggHeading40>
      <div className={classes.divider} />
      <Grid container direction="column" spacing={6}>
        {actions
          .filter(action => action.condition())
          .map((action, i) => (
            <Grid item key={`advnaced-action-${i}`} id={`advanced-action-${action.type}`}>
              {React.createElement(action.component, {
                key: action.type
              })}
            </Grid>
          ))}
      </Grid>
    </div>
  )
}

export default AdvancedActions
